import { useQuery } from '@tanstack/react-query';
import { EmptyState, LoadingState, apiRequest } from '@tpct/admin-ui';
import type { CompanyStatsResponse } from '../../types/company-page';
import StatCard from './StatCard';
import { __ } from '@/hub-shared/utils/i18n';

type StatsSectionProps = {
  companyId: number;
  bootstrapKey: string;
};

const StatsSection = ({ companyId, bootstrapKey }: StatsSectionProps) => {
  const { data, isLoading, isError } = useQuery<CompanyStatsResponse>({
    queryKey: ['company-stats', companyId],
    queryFn: () =>
      apiRequest<CompanyStatsResponse>(
        `company/${companyId}/stats`,
        {},
        bootstrapKey,
      ),
    enabled: companyId > 0,
  });

  if (isLoading) {
    return (
      <LoadingState columns={[__('Indicateur'), __('Valeur')]} className="company-stats-loading" />
    );
  }

  if (isError) {
    return (
      <EmptyState
        title={__('Erreur de chargement')}
        description={__('Impossible de charger les indicateurs.')}
      />
    );
  }

  if (!data || data.items.length === 0) {
    return (
      <EmptyState
        title={__('Aucun indicateur disponible')}
        description={__('Les statistiques apparaîtront ici au fur et à mesure que les outils sont connectés à cette entreprise.')}
      />
    );
  }

  return (
    <div className="company-stats">
      {data.items.map((item) => (
        <StatCard
          key={item.key}
          label={item.label}
          value={item.value}
          unit={item.unit}
          delta={item.delta}
          delta_label={item.delta_label}
        />
      ))}
    </div>
  );
};

export default StatsSection;
